<template>
    <div class="card shadow mb-3" id="filtercard">
        <div class="card-body">
            <div class="row inline">
                <h4 class="mt-3 col-10">{{ $trans.get('__JSON__.Select filters') }}</h4>
                <div class="col-2 ">
                    <span :disabled="isExecutable" @click.prevent="downloadList" class="material-symbols-outlined float-end text-primary mr-3"
                        style="font-size: 2.5rem;" role="button" v-tooltip
                        :title="$trans.get('__JSON__.Download xlsx')">
                        file_save
                    </span>
                    <span v-if="loading" class="spinner-border text-primary float-right" role="status"
                        style="width: 2rem; height: 2rem;  border-width: 10px !important;"
                        aria-hidden="true"></span>
                </div>
            </div>
            <div class="row inline">
                <!-- <div class="col-3">
                        <multiselect-locations/>
                    </div> -->
                <div class="col-2">
                    <multiselect-employers @selectedemployers-Changed="setSelectedEmployers"> </multiselect-employers>
                </div>
                <div class="col-2">
                    <multiselect-teams @selectedteams-Changed="setSelectedTeams"> </multiselect-teams>
                </div>
                <div class="col-2">
                    <multiselect-locations2 @selectedlocations-Changed="setSelectedLocations"> </multiselect-locations2>
                </div>
                <div class="col-1">
                    <button :disabled="listing" class="btn btn-primary float-start" type="button" @click.prevent="loadEmployees">
                        <span class="mt-1 material-symbols-outlined">
                            refresh
                        </span>
                    </button>
                    <span v-if="listing==true"  class="spinner-border text-primary float-left ml-1 mt-2" role="status"
                        style="width: 1rem; height: 1rem;  border-width: 10px !important;"
                        aria-hidden="true"></span>

                </div>
            </div>
        </div>
    </div>
    <div v-show="!isEmpty" class="card shadow result-card">
        <div class="card-body resultcard">
            <div class="table-responsive resultcard">
                <table class="table table-striped text-nowrap result-card">
                    <thead v-if="small==0" id="fixed-thead">
                        <tr>
                            <th>{{ $trans.get('__JSON__.' + 'Name') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Employeenumber') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Employer') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Team') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Location') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Division') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Birthday') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Default costcentre') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Street') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'House number') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'City') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'State') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Country') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Postal code') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Nationality') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Badge number') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Phone') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Email') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Administrative') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Vacation profile') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Salery type') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Worktime model') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Employer rate') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Mail notifications') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Flextime') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Handicaped') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Stamps required') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'school children') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Bonuses') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Locker number') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Locker location') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Remarks') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Flextime Hours') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Days left') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Days used') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Days requested') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Days granted') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Inactive') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="small==0" >
                        <tr v-for="employee in exportlistEmployees">
                            <td>{{ employee.lastname }}, {{ employee.forename }}</td>
                            <td>{{ employee.employeenumber }}</td>
                            <td>{{ employee.employer?.name }}</td>
                            <td>{{ employee.team?.name }}</td>
                            <td>{{ employee.location?.name }}</td>
                            <td>{{ employee.division?.name }}</td>
                            <td>{{ employee.birthday }}</td>
                            <td>{{ employee.default_costcentre }}</td>
                            <td>{{ employee.street }}</td>
                            <td>{{ employee.house_number }}</td>
                            <td>{{ employee.city }}</td>
                            <td>{{ employee.state }}</td>
                            <td>{{ employee.country }}</td>
                            <td>{{ employee.postal_code }}</td>
                            <td>{{ employee.nationality }}</td>
                            <td>{{ employee.badgenumber }}</td>
                            <td>{{ employee.phone }}</td>
                            <td>{{ employee.email }}</td>
                            <td>{{ employee.administrative }}</td>
                            <td>{{ employee.vacationprofile?.name }}</td>
                            <td>{{ getTranslation(employee.salerytype?.name) }}</td>
                            <td>{{ employee.worktime?.name }}</td>
                            <td>{{ employee.employerrate?.name }} (€{{ employee.employerrate?.hourlyrate }})</td>
                            <td>{{ employee.mail_notifications }}</td>
                            <td>{{ employee.flextime }}</td>
                            <td>{{ employee.handicaped }}</td>
                            <td>{{ employee.stamps_required }}</td>
                            <td>{{ employee.school_children }}</td>
                            <td>{{ employee.employee_bonus_profile?.name }}</td>
                            <td>{{ employee.locker_number }}</td>
                            <td>{{ employee.lockerlocation?.name }}</td>
                            <td v-html="employee.remarks"></td>
                            <td>{{ employee.actualFlextimeHours }}</td>
                            <td>{{ employee.vacationData?.daysLeft }}</td>
                            <td>{{ employee.vacationData?.daysUsed }}</td>
                            <td>{{ employee.vacationData?.daysRequested }}</td>
                            <td>{{ employee.vacationData?.daysGranted }}</td>
                            <td>{{ employee.inactive ? 'ja' : 'nein' }}</td>
                        </tr>
                    </tbody>
                    <thead v-if="small==1" id="fixed-thead">
                        <tr>
                            <th>{{ $trans.get('__JSON__.' + 'Name') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Employeenumber') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Employer') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Team') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Location') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Division') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Default costcentre') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Worktime model') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Locker number') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Locker location') }}</th>
                            <th>{{ $trans.get('__JSON__.' + 'Inactive') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="small==1" >
                        <tr v-for="employee in exportlistEmployees">
                            <td>{{ employee.lastname }}, {{ employee.forename }}</td>
                            <td>{{ employee.employeenumber }}</td>
                            <td>{{ employee.employer?.name }}</td>
                            <td>{{ employee.team?.name }}</td>
                            <td>{{ employee.location?.name }}</td>
                            <td>{{ employee.division?.name }}</td>
                            <td>{{ employee.default_costcentre }}</td>
                            <td>{{ employee.worktime?.name }}</td>
                            <td>{{ employee.locker_number }}</td>
                            <td>{{ employee.lockerlocation?.name }}</td>
                            <td>{{ employee.inactive ? 'ja' : 'nein' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import getExportlistEmployees from "../composables/getEmployeeExportlist";
import Axios from "axios";

export default {

    setup() {
        const { exportlistEmployees, exportlistEmployees_error, loadExportlistEmployees } = getExportlistEmployees();

        return { exportlistEmployees, exportlistEmployees_error, loadExportlistEmployees };
    },
    props: {
        small: Number,
    },
    data() {
        return {
            selectedEmployers: [],
            loading: false,
            percentCompleted: 0,
            listing: false,
            isExecutable: false,
        }
    },
    updated() {
        // calculate height of result card based on window size
        // console.log("WindowViewPortHeight: " , $("#app").height());
        // console.log("Navbar Height: " , $(".navbar").outerHeight(true));
        // console.log("main margin top: " , parseInt($("main").css("margin-top"),10));
        // console.log("FilterCard Height" , $("#filtercard").outerHeight(true) );
        let resultcardheight = $("#app").height() - $(".navbar").outerHeight(true) - parseInt($("main").css("margin-top"),10) - $("#filtercard").outerHeight(true) - 32;
        // console.log("resultcard heigth: ", resultcardheight);
        $(".resultcard").height(resultcardheight);

        // sticky header
        var element = document.getElementById("fixed-thead");
        var parentElement = element.parentElement;
        window.addEventListener('scroll', () => {
            var coordinates = parentElement.getBoundingClientRect();
            if (coordinates.y < 0) {
                element.style.transform = 'translate3d(0, ' + (-coordinates.y) + 'px, 0)';
            } else {
                element.style.transform = 'translate3d(0,0,0)';
            }
        });
    },
    mounted() {
        $(window).on("resize", function() {
            setTimeout(() => {
                let resultcardheight = $("#app").height() - $(".navbar").outerHeight(true) - parseInt($("main").css("margin-top"),10) - $("#filtercard").outerHeight(true) - 32;
                $(".resultcard").height(resultcardheight);
            },500);
        });
    },
    computed: {
        isEmpty: function () {
            return jQuery.isEmptyObject(this.exportlistEmployees);
        }
    },
    watch: {
        percentCompleted(newValue, oldValue) {
            console.log("changed");
            if(this.percentCompleted == 100) {
                this.loading = false;
            }
        },
        exportlistEmployees(newValue, oldValue) {
            console.log("end listing")
            this.listing = false;
            this.isExecutable = true;
        },

    },
    methods: {
        setSelectedEmployers(selectedEmployersMultiSel) {
            //console.log("emit listener: ", selectedEmployersMultiSel);
            this.selectedEmployers = [];
            selectedEmployersMultiSel.forEach(element => {
                this.selectedEmployers.push(element.value);
            });
        },
        setSelectedTeams(selectedTeamsMultiSel) {
            this.selectedTeams = [];
            selectedTeamsMultiSel.forEach(element => {
                this.selectedTeams.push(element.value);
            });
        },
        setSelectedLocations(selectedLocationsMultiSel) {
            this.selectedLocations = [];
            selectedLocationsMultiSel.forEach(element => {
                this.selectedLocations.push(element.value);
            });
        },
        loadEmployees() {
            if(this.selectedEmployers.length > 0 || this.selectedLocations.length > 0 || this.selectedTeams.length > 0){
                console.log("start listing")
                this.listing = true;
                this.isExecutable = false;
                this.loadExportlistEmployees(this.selectedEmployers, this.selectedTeams, this.selectedLocations);
            }
        },
        getTranslation(string) {
            if (string) {
                let string_translated = this.$trans.get("__JSON__." + string);
                return string_translated;
            }
            return string = '';
        },
        downloadList() {
            $('.tooltip').css('display', 'none');
            // console.log("start");
            if (this.selectedEmployers.length > 0 || this.selectedLocations.length > 0 || this.selectedTeams.length > 0) {
                this.loading = true;
                var params = [];
                params.push(['employers', this.selectedEmployers]);
                params.push(['teams', this.selectedTeams]);
                params.push(['locations', this.selectedLocations]);
                let url = "/api/employees/export/download?" + new URLSearchParams(params);
                let label = 'employeelist.xlsx'

                // console.log("url", url);
                Axios.get(url, {
                    responseType: 'blob', onDownloadProgress: (progressEvent) => {
                        this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total); 
                    }
                })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = label
                        link.click()
                        URL.revokeObjectURL(link.href)
                    }).catch(console.error)
            }
            //this.loading = false;
            // console.log("finish");
        }
    }
}


</script>
